import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlag } from '../../../shared/models/enums/feature-flag';
import { JobComplianceRequirement, JobComplianceRequirementChanges, JobRequirementsService, JobsRequirementsImportResult } from '../../job-requirements/job-requirements.service';
import { JobRequirementsClient } from '../job-requirements-client.service';
import { JobRequirementChangesDto } from '../models/job-requirement-changes-dto.model';
import { JobRequirementDto } from '../models/job-requirement-dto.model';
import { JobsRequirementsImportResultDto } from '../models/jobs-requirements-import-result-dto.model';
import { NSwagMigrationService } from './nswag-migration.service';


// 3 endpoints
@Injectable({ providedIn: 'root' })
export class JobRequirementsNSwagMigrationService extends NSwagMigrationService {
    protected readonly className = 'JobRequirementsNSwagMigrationService';
    protected readonly featureFlag = FeatureFlag.NSwagMigrationJobRequirementsService;
    private readonly legacy = inject(JobRequirementsService);
    private readonly jobRequirementsClient = inject(JobRequirementsClient);

    // ** JobRequirementsController.Import
    importJobRequirements(
        facilityId: number,
        validateOnly: boolean,
        data: FormData
    ): Observable<JobsRequirementsImportResult | JobsRequirementsImportResultDto> {
        const file = data.get('file') as File;
        return this.invoke(x => x
            ? this.legacy.importJobRequirements(facilityId, validateOnly, data)
            : this.jobRequirementsClient.import(facilityId, validateOnly, { data: file, fileName: file.name }));
    }

    // ** JobRequirementsController.Get
    getJobRequirements(jobId: number): Observable<JobComplianceRequirement[] | JobRequirementDto[]> {
        return this.invoke(x => x
            ? this.legacy.getJobRequirements(jobId)
            : this.jobRequirementsClient.get(jobId));
    }

    // ** JobRequirementsController.GetJobRequirementChanges
    getJobRequirementsChanges(jobId: number, contractId: number): Observable<JobComplianceRequirementChanges | JobRequirementChangesDto> {
        return this.invoke(x => x
            ? this.legacy.getJobRequirementsChanges(jobId, contractId)
            : this.jobRequirementsClient.getJobRequirementChanges(jobId, contractId));
    }
}
